import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "subscription-info" }
const _hoisted_2 = {
  key: 0,
  class: "subs-title w-s-nw"
}
const _hoisted_3 = {
  key: 1,
  class: "subs-title w-s-nw"
}
const _hoisted_4 = { class: "subscription-info__info" }
const _hoisted_5 = { class: "subscription-info__info--price" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "/month", -1)
const _hoisted_7 = {
  key: 0,
  class: "subscription-info__info--expire"
}
const _hoisted_8 = {
  key: 0,
  class: "c-secondary-black"
}
const _hoisted_9 = {
  key: 1,
  class: "c-secondary-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconsSubscription = _resolveComponent("IconsSubscription")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconsSubscription, {
      plan: _ctx.$props.plan
    }, null, 8, ["plan"]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$props.plan, "subscription-info__title m-left-20"])
    }, [
      (_ctx.$props.altTitle)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.SUBSCRIPTION_PLAN_ALTERNATIVE_TITLE[_ctx.$props.plan]), 1))
        : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.SUBSCRIPTION_PLAN_TITLE[_ctx.$props.plan]), 1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, [
            _createElementVNode("b", null, "$" + _toDisplayString(_ctx.subscriptions[_ctx.$props.plan].price), 1)
          ]),
          _hoisted_6
        ]),
        (_ctx.$props.showExpire && (_ctx.profile?.subscription?.end_date || _ctx.profile?.subscription?.downgrade_date))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.profile?.subscription?.end_date)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Expires on " + _toDisplayString(_ctx.getDate(_ctx.profile?.subscription?.end_date)), 1))
                : _createCommentVNode("", true),
              (_ctx.profile?.subscription?.downgrade_date)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Downgrade on " + _toDisplayString(_ctx.getDate(_ctx.profile?.subscription?.downgrade_date)), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}